import React, { useState } from 'react';
import './Works.scss';
import { images } from '../../constants';
import { AiFillEye, AiFillGithub } from 'react-icons/ai';
import { motion } from 'framer-motion';
import { AppWrap, MotionWrap } from '../../wrapper';
import { useNavigate } from 'react-router-dom';



const portfolios = [
    { id: 1, name: 'Manufacturing website', projectLink: 'https://refrigerator-manufacturing.web.app/', codeLink: 'https://github.com/Imrancu/manufacturing-website-client', title: 'Web Development', imgUrl: images.refrigerator },
    { id: 2, name: 'Gym Equipment App', projectLink: 'https://gym-equipment-13125.web.app/', codeLink: 'https://github.com/Imrancu/warehouse-management-client', title: 'Front-End Development', imgUrl: images.gymEquipment },
    { id: 3, name: 'Dental Solution', projectLink: 'https://dental-solution-2564b.web.app/', codeLink: 'https://github.com/Imrancu/independent-service-provider-website', title: 'Back-End', imgUrl: images.dentalSolution },
]

const Works = () => {
    const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });


    const navigate = useNavigate()
    const handleWorkDetails = (id) => {
      navigate(id)
    }

    return (
        <>
      <h2 className="head-text">My Recent <span>Portfolio</span> Section</h2>
      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {portfolios.map((portfolio, index) => (
          <div className="app__work-item app__flex" key={index}>
            <div
              className="app__work-img app__flex"
            >
              <img src={portfolio.imgUrl} alt={portfolio.name} />

              <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{ duration: 0.25, ease: 'easeInOut', staggerChildren: 0.5 }}
                className="app__work-hover app__flex"
              >
                <a href={portfolio.projectLink} target="_blank" rel="noreferrer">

                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.90] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillEye />
                  </motion.div>
                </a>
                <a href={portfolio.codeLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.90] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillGithub />
                  </motion.div>
                </a>
              </motion.div>
            </div>

            <div className="app__work-content app__flex">
              <h4 className="bold-text">{portfolio.name}</h4>
              <p className="p-text" style={{ marginTop: 10 }}>{portfolio.description}</p>
              <button onClick={()=> handleWorkDetails(portfolio.id)} className='app__flex explore-btn'>Explore</button>
            </div>
          </div>
        ))}
      </motion.div>
    </>
    );
};

export default AppWrap(
    MotionWrap(Works, 'app__works'),
    'portfolio',
    'app__primarybg',
  );